export const CFA_INFO = {
  name: 'Zillenium Alternance',
  legalName: 'ZILLENIUM SAS',
  siret: '899 403 257 00020',
  uai: '0891340Y',
  nda: '27890185489',
  address: '25 rue Gabriel Cortel, 89300 Joigny',
  president: 'Samir MOKEDDEM',
  phone: '09 83 49 01 81',
  email: 'contact@zilleniumalternance.fr',
  rgpdEmail: 'rgpd@zilleniumalternance.fr',
  host: 'IONOS',
  tagline: 'Apprendre, Faire, Briller !',
}

export const LINKS = {
  // Forms are now natively integrated into the site
}

// Numéro WhatsApp du chat du site (format international, sans "+" ni espaces).
// Mobile pro : 07 81 53 72 15 -> 33781537215
export const WHATSAPP_NUMBER = '33781537215'

export type Formation = {
  id: string
  title: string
  /** Formation mise en avant comme nouveauté sur le site */
  isNew?: boolean
  /** Lien de téléchargement du programme de formation (PDF) */
  catalogueUrl?: string
  level: string
  rncp: string
  duration: string
  rhythm: string
  session: string
  rentree: string
  description: string
  objectives: string
  public: string
  prerequisites: string
  acces: string
  delaiAcces: string
  methods: string
  evaluation: string
  epreuve: string
  certification: {
    intitule: string
    niveauDomaine: string
    certificateur: string
    enregistrement: string
    derniereDelivrance?: string
    lien: string
    blocs: { code: string; description: string }[]
    capitalisation: string
    correspondance?: string
  }
  opportunities: string[]
  romeCodes: string[]
  secteurs: string
  furtherStudies: string
  handicap: string
  price: string
  indicators: { label: string; value: string; detail?: string }[]
}

export const FORMATIONS: Formation[] = [
  {
    id: 'bts-ndrc',
    title: 'BTS NDRC',
    catalogueUrl: '/documents/Programme_BTS_NDRC.pdf',
    level: 'Niveau 5',
    rncp: 'RNCP38368',
    duration: 'Parcours en alternance sur 2 ans, session 2026–2028.',
    rhythm: '3 jours en entreprise et 2 jours en centre de formation. (Lundi, Mardi)',
    session: '2026–2028',
    rentree: '25 septembre 2026, sous réserve de places disponibles.',
    description: "Le BTS Négociation et digitalisation de la relation client forme des commerciaux généralistes capables d'agir en présentiel, à distance, en e-relation et au sein de réseaux.",
    objectives: "À l'issue du parcours, l'apprenant sera capable de cibler et prospecter une clientèle, négocier une solution, organiser une action commerciale, exploiter l'information client, animer la relation digitale, développer l'e-commerce et contribuer à un réseau de distributeurs, partenaires ou vente directe.",
    public: "Candidats souhaitant exercer dans la prospection, la négociation, la gestion de clientèle, la vente à distance, l'e-commerce ou l'animation commerciale.",
    prerequisites: 'Niveau 4 validé ou parcours compatible, expression écrite et orale solide, bases numériques, motivation commerciale et projet validé après positionnement.',
    acces: "Candidature, entretien, positionnement, validation du projet et contrat d'apprentissage.",
    delaiAcces: 'Selon calendrier, date de candidature, places disponibles et contractualisation.',
    methods: 'Apports structurés, études de cas, entraînements de négociation, CRM et outils digitaux, projets commerciaux, e-commerce, jeux de rôle et suivi individualisé.',
    evaluation: "Contrôles, dossiers, oraux, situations professionnelles, productions digitales et bilans d'acquisition.",
    epreuve: "Épreuves selon règlement du BTS : CCF lorsque l'habilitation le permet ou forme ponctuelle.",
    certification: {
      intitule: 'BTS - Négociation et digitalisation de la relation client.',
      niveauDomaine: 'Niveau 5 • NSF 312 Commerce, vente • Relation client et force de vente.',
      certificateur: "Ministère de l'Enseignement Supérieur et de la Recherche.",
      enregistrement: 'Début des parcours : 01/01/2024 – Échéance : 31/12/2028.',
      derniereDelivrance: 'Dernière délivrance possible mentionnée : 31/12/2031.',
      lien: 'francecompetences.fr/recherche/rncp/38368/',
      blocs: [
        { code: 'RNCP38368BC01', description: 'Relation client et négociation-vente : prospection, négociation, événement commercial, information commerciale.' },
        { code: 'RNCP38368BC02', description: 'Relation client à distance et digitalisation : omnicanal, relation digitale, e-commerce.' },
        { code: 'RNCP38368BC03', description: 'Relation client et animation de réseaux : distributeurs, partenaires, vente directe.' },
      ],
      capitalisation: 'Chaque unité correspond à un bloc ; dispense possible des épreuves déjà validées selon règlement du diplôme.',
    },
    opportunities: ['Commercial terrain', 'Négociateur', 'Conseiller commercial', 'Chargé de clientèle', 'Technico-commercial', 'Téléconseiller', 'Commercial e-commerce', 'Chef de secteur', 'Animateur réseau'],
    romeCodes: ['D1401', 'D1406', 'D1501', 'M1703', 'M1704'],
    secteurs: 'Toute organisation commerciale, industrielle, artisanale, associative ou publique avec démarche commerciale.',
    furtherStudies: "Poursuites d'études possibles (non précisées dans le catalogue).",
    handicap: 'Étude individualisée des besoins. Référent handicap : samir@zilleniumalternance.fr.',
    price: "15 390 € — pris en charge à 100 % par l'OPCO de l'entreprise, soit 0 € pour l'apprenti sous contrat d'apprentissage.",
    indicators: [
      { label: '2027', value: 'Session BTS 2025–2027 : examen prévu en 2027, résultat non disponible.' },
      { label: '2028', value: 'Session BTS 2026–2028 : examen prévu en 2028, indicateur publié après jury.' },
    ],
  },
  {
    id: 'tp-conseiller-vente',
    title: 'TP CONSEILLER DE VENTE',
    catalogueUrl: '/documents/Programme_TP_Conseiller_de_Vente.pdf',
    level: 'Niveau 4',
    rncp: 'RNCP37098',
    duration: 'Parcours en alternance sur 1 an, session 2026–2027.',
    rhythm: '4 jours en entreprise et 1 jour en centre de formation (mercredi)',
    session: '2026–2027',
    rentree: '25 septembre 2026, sous réserve de places disponibles.',
    description: "Le parcours prépare à conseiller des clients, animer l'offre commerciale, traiter les flux marchands et contribuer aux résultats d'une unité marchande.",
    objectives: "À l'issue du parcours, l'apprenant sera capable de réaliser une veille commerciale, traiter une réception et une opération promotionnelle, conduire un entretien de vente, gérer une réclamation, suivre ses ventes et proposer des actions d'amélioration à partir d'indicateurs.",
    public: 'Candidats souhaitant exercer dans la vente, le conseil client, la relation omnicanale, le commerce de proximité, la grande distribution ou les magasins spécialisés.',
    prerequisites: 'Compréhension orale et écrite du français, bases de calcul commercial, aisance relationnelle, projet professionnel validé après entretien et positionnement.',
    acces: "Candidature, entretien, positionnement, validation du projet et contrat d'apprentissage.",
    delaiAcces: 'Selon calendrier, date de candidature, places disponibles et contractualisation.',
    methods: 'Apports ciblés, ateliers produits, cas de réception, merchandising, jeux de rôle vente/réclamation, tableau de bord, productions professionnelles et accompagnement individualisé.',
    evaluation: 'Quiz, mises en situation, études de cas, fiches produits, diaporama, entretiens simulés et dossier professionnel.',
    epreuve: 'Épreuve globale 3 h 55 : mise en situation 2 h, entretien technique 30 min, productions 1 h 10, entretien final 15 min.',
    certification: {
      intitule: 'TP - Conseiller de vente.',
      niveauDomaine: 'Niveau 4 • NSF 312m Commerce, vente • Formacode 34502.',
      certificateur: "Ministère du Travail, du Plein Emploi et de l'Insertion.",
      enregistrement: 'Début des parcours : 25/01/2023 – Échéance : 25/01/2028.',
      lien: 'francecompetences.fr/recherche/rncp/37098/',
      blocs: [
        { code: 'RNCP37098BC01', description: 'Efficacité commerciale omnicanale : veille, flux marchands, merchandising, analyse des performances et compte rendu.' },
        { code: 'RNCP37098BC02', description: "Expérience client omnicanale : image de l'unité, entretien de vente, suivi des ventes, fidélisation." },
      ],
      capitalisation: 'Deux certificats de compétences professionnelles capitalisables selon les règles du titre professionnel.',
      correspondance: "Correspondance partielle avec l'ancien RNCP13620 TP Vendeur(se)-conseil en magasin.",
    },
    opportunities: ['Conseiller clientèle', 'Vendeur expert', 'Vendeur conseil', 'Vendeur technique', 'Vendeur en magasin', 'Magasinier vendeur'],
    romeCodes: ['D1209', 'D1214', 'D1211', 'D1212', 'D1210'],
    secteurs: 'GMS, surfaces spécialisées, grands magasins, boutiques, proximité, négoces interentreprises, gros.',
    furtherStudies: "Poursuites d'études possibles (non précisées dans le catalogue).",
    handicap: 'Étude individualisée des besoins. Référent handicap : samir@zilleniumalternance.fr.',
    price: "6 390 € — pris en charge à 100 % par l'OPCO de l'entreprise, soit 0 € pour l'apprenti sous contrat d'apprentissage.",
    indicators: [
      { label: '100 %', value: 'Taux de réussite constaté pour la session TP 2024–2025.' },
      { label: 'À venir', value: 'Session TP 2026–2027 : examen non encore passé, indicateur publié après jury.' },
    ],
  },
  {
    id: 'tp-ntc',
    title: 'TP NÉGOCIATEUR TECHNICO-COMMERCIAL',
    isNew: true,
    catalogueUrl: '/documents/Programme_TP_Negociateur_Technico_Commercial.pdf',
    level: 'Niveau 5',
    rncp: 'RNCP39063',
    duration: 'Parcours en alternance sur 1 an, session 2026–2027.',
    rhythm: '4 jours en entreprise et 1 jour en centre de formation (mardi)',
    session: '2026–2027',
    rentree: '25 septembre 2026, sous réserve de places disponibles.',
    description: "Le parcours prépare à prospecter et développer un portefeuille clients en B2B, élaborer des propositions technico-commerciales personnalisées, négocier en posture d'expert-conseil et fidéliser une clientèle professionnelle.",
    objectives: "À l'issue du parcours, l'apprenant sera capable d'élaborer une stratégie de prospection, organiser et mettre en œuvre un plan d'action commercial, concevoir et négocier une proposition technico-commerciale, assurer le suivi des affaires et fidéliser un portefeuille de clients en B2B.",
    public: "Candidats souhaitant exercer dans la vente technique ou de solutions en B2B, la prospection et le développement commercial auprès d'une clientèle professionnelle.",
    prerequisites: 'Niveau 4 validé ou parcours compatible, aisance relationnelle et orale, bases commerciales ou techniques, projet professionnel validé après entretien et positionnement.',
    acces: "Candidature, entretien, positionnement, validation du projet et contrat d'apprentissage.",
    delaiAcces: 'Selon calendrier, date de candidature, places disponibles et contractualisation.',
    methods: "Apports structurés, études de cas clients, simulations de négociation, techniques de prospection multicanale, construction d'offres technico-commerciales, jeux de rôle et accompagnement individualisé.",
    evaluation: "Contrôles, dossiers commerciaux, mises en situation de négociation, productions professionnelles et bilans d'acquisition.",
    epreuve: "Épreuve globale : mise en situation de négociation, entretien technique sur le dossier de pratique professionnelle, entretien final.",
    certification: {
      intitule: 'TP - Négociateur technico-commercial.',
      niveauDomaine: 'Niveau 5 • NSF 312 Commerce, vente • Négociation technico-commerciale.',
      certificateur: "Ministère du Travail, du Plein Emploi et de l'Insertion.",
      enregistrement: 'Échéance : 10/06/2029.',
      lien: 'francecompetences.fr/recherche/rncp/39063/',
      blocs: [
        { code: 'RNCP39063BC01', description: 'Prospecter et développer un portefeuille de clients en B2B : veille marché, stratégie de prospection, ciblage et prise de contact multicanale.' },
        { code: 'RNCP39063BC02', description: "Concevoir et négocier une proposition technico-commerciale : analyse du besoin, élaboration d'une offre personnalisée, argumentation et négociation en posture d'expert-conseil." },
        { code: 'RNCP39063BC03', description: "Gérer et fidéliser un portefeuille clients : suivi des affaires, satisfaction client, actions de fidélisation et développement du chiffre d'affaires." },
      ],
      capitalisation: 'Chaque bloc correspond à un certificat de compétences professionnelles capitalisable selon les règles du titre professionnel.',
    },
    opportunities: ['Technico-commercial', "Ingénieur commercial", "Chargé d'affaires", 'Délégué commercial', 'Représentant commercial B2B', 'Commercial sédentaire'],
    romeCodes: ['D1407', 'D1402', 'D1401'],
    secteurs: 'Industrie, négoce technique, informatique, bâtiment, services aux entreprises, distribution professionnelle.',
    furtherStudies: "Poursuites d'études possibles (non précisées dans le catalogue).",
    handicap: 'Étude individualisée des besoins. Référent handicap : samir@zilleniumalternance.fr.',
    price: "9 000 € — pris en charge à 100 % par l'OPCO de l'entreprise, soit 0 € pour l'apprenti sous contrat d'apprentissage.",
    indicators: [
      { label: 'En cours', value: "Session 2026–2027 en cours : démarrage en septembre 2026, indicateurs de résultats publiés à l'issue du premier jury." },
      { label: 'À venir', value: 'Nouvelle formation : aucune session achevée à ce jour, aucun indicateur de réussite ou de satisfaction disponible.' },
    ],
  },
]

export const SITE_LAST_UPDATED = '21 juin 2026'

export const QUALIOPI_LOGO =
  'https://cdn.magicpatterns.com/uploads/rwudtnGwLJZu2WNjgrZHAa/Capture_d’ecran_2026-06-21_a_16.25.29.png'

export const DOCUMENTS = [
  {
    id: 'qualiopi-apprentissage',
    title: 'Certificat Qualiopi - Apprentissage',
    description: "Certificat Qualiopi pour les actions de formation par apprentissage (valable jusqu'au 30/10/2027).",
    url: '/documents/Certificat_Qualiopi_Formation_par_apprentissage.pdf',
  },
  {
    id: 'qualiopi-formation',
    title: 'Certificat Qualiopi - Formation continue',
    description: "Certificat Qualiopi pour les actions de formation (valable jusqu'au 01/09/2027).",
    url: '/documents/Certificat_Qualiopi_Actions_de_formation.pdf',
  },
  {
    id: 'indicateurs',
    title: 'Indicateurs de résultats détaillés',
    description: 'Détail des indicateurs de performance et de réussite de nos formations.',
  },
  {
    id: 'catalogue',
    title: 'Catalogue de formation',
    description: 'Présentation complète de notre offre de formation.',
  },
  {
    id: 'cgv',
    title: 'Conditions Générales de Vente',
    description: "CGV applicables à l'ensemble de nos prestations.",
  },
  {
    id: 'info-psh',
    title: "Document d'information PSH",
    description: "Informations et modalités d'accueil pour les Personnes en Situation de Handicap.",
  },
]
